import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FlashFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M1.90503 12.0001L8.79459 6.25879V9.78364H10.9658V14.2164H8.79459V17.7414L1.90503 12.0001ZM22.095 12.0001L15.2055 6.25879V9.78364H13.0343V14.2164H15.2055V17.7414L22.095 12.0001Z"
      />
    </SvgIcon>
  );
});
